// extracted by mini-css-extract-plugin
export default {"container":"main_container__Np5Lz","main":"main_main__WycL9"};